import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

export const PopoverHeading = styled.div`
  background: ${colors.lightBg};
  letter-spacing: -0.25pt;
  font-size: 85%;
  text-transform: uppercase;
  font-weight: bold;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
`;
